import React from "react";
import { fromJS } from "immutable";
import { useRejectedCore } from "APP_ROOT/hooks";
import pojo from "LIB/pojos";
import Section from "MODULES/shared/components/Section";
import ShippingAddress from "MODULES/Orders/shared/ShippingAddress";
import { PhysicalAddress } from "MODULES/shared/components/PhysicalAddress/PhysicalAddress";
import {
  SHIP_TO,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIP_TO_SHIPPING_ADDRESS,
  SHIP_TO_SHIPPING_METHOD,
  SHIP_TO_TYPE
} from "APP_ROOT/constants";
import Form from "./ShipToForm";

export default function ShipTo() {
  const rejectedCore = useRejectedCore();

  const initialValues = pojo(rejectedCore).pick(
    SHIP_TO_TYPE,
    SHIP_TO_COMPANY_ID,
    SHIP_TO_COMPANY_ADDRESS_ID,
    SHIP_TO_SHIPPING_ADDRESS,
    SHIP_TO_SHIPPING_METHOD
  );

  const renderForm = close => (
    <Form
      close={close}
      rejectedCore={rejectedCore}
      initialValues={initialValues}
    />
  );

  return (
    <Section
      title="Ship To"
      modal={{
        title: "Edit Shipping",
        content: renderForm
      }}
      editable={!rejectedCore.shipped}
    >
      {!rejectedCore.ship_to_type && <PhysicalAddress address={{}} />}
      <ShippingAddress shippingType={SHIP_TO} record={fromJS(rejectedCore)} />
    </Section>
  );
}



// WEBPACK FOOTER //
// ./app/modules/RejectedCores/components/Detail/ShipTo.jsx